import { COUNT_UP_CSS } from './countUpWidget';

const ENTERS = ['none', 'up', 'left', 'right', 'zoom'];
const LOOPS = ['none', 'float', 'pulse'];

/** Lê o movimento gravado no elemento. Sem campo, nada se mexe. */
export function normalizeMotion(content) {
  const raw = (content && content.motion) || {};
  const enter = ENTERS.includes(raw.enter) ? raw.enter : 'none';
  const loop = LOOPS.includes(raw.loop) ? raw.loop : 'none';
  let delay = Number(raw.delay);
  if (!Number.isFinite(delay)) delay = 0;
  delay = Math.max(0, Math.min(800, Math.round(delay / 50) * 50));
  return { enter, loop, delay };
}

export function motionClassName(content) {
  const motion = normalizeMotion(content);
  if (motion.enter === 'none') return '';
  return `madri-motion madri-motion--${motion.enter}`;
}

export function motionInlineStyle(content) {
  const motion = normalizeMotion(content);
  if (motion.enter === 'none' && motion.loop === 'none') return '';
  return `--madri-motion-delay:${motion.delay}ms;`;
}

/** O loop fica no miolo, para a barra de edição do palco não balançar junto. */
export function applyMotionToInnerHtml(innerHtml, content) {
  const motion = normalizeMotion(content);
  let html = innerHtml || '';
  if (motion.loop !== 'none') {
    html = `<div class="madri-motion madri-motion--${motion.loop} madri-motion__loop">${html}</div>`;
  }
  if (motion.enter !== 'none') {
    html += '<script>(function(){var s=document.currentScript;var el=s&&s.closest(".widget-block,.widget-wrapper");if(!el)return;function show(){el.classList.add("is-in");}if(window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches){show();return;}if(!("IntersectionObserver"in window)){show();return;}var io=new IntersectionObserver(function(list){list.forEach(function(en){if(en.isIntersecting){show();io.disconnect();}});},{threshold:0.2});io.observe(el);})();</script>';
  }
  return html;
}

export const MOTION_CSS = `
.madri-motion--up{opacity:0;transform:translate3d(0,28px,0)}
.madri-motion--left{opacity:0;transform:translate3d(-36px,0,0)}
.madri-motion--right{opacity:0;transform:translate3d(36px,0,0)}
.madri-motion--zoom{opacity:0;transform:scale(.92)}
.madri-motion--up.is-in{animation:madriInUp .75s ease forwards;animation-delay:var(--madri-motion-delay,0ms)}
.madri-motion--left.is-in{animation:madriInLeft .75s ease forwards;animation-delay:var(--madri-motion-delay,0ms)}
.madri-motion--right.is-in{animation:madriInRight .75s ease forwards;animation-delay:var(--madri-motion-delay,0ms)}
.madri-motion--zoom.is-in{animation:madriInZoom .75s ease forwards;animation-delay:var(--madri-motion-delay,0ms)}
@keyframes madriInUp{from{opacity:0;transform:translate3d(0,28px,0)}to{opacity:1;transform:none}}
@keyframes madriInLeft{from{opacity:0;transform:translate3d(-36px,0,0)}to{opacity:1;transform:none}}
@keyframes madriInRight{from{opacity:0;transform:translate3d(36px,0,0)}to{opacity:1;transform:none}}
@keyframes madriInZoom{from{opacity:0;transform:scale(.92)}to{opacity:1;transform:none}}
.madri-motion--float{animation:madriFloat 3.4s ease-in-out infinite}
.madri-motion--pulse{animation:madriPulse 2.6s ease-in-out infinite}
.madri-motion__loop{width:100%}
@keyframes madriFloat{0%,100%{transform:translate3d(0,0,0)}50%{transform:translate3d(0,-10px,0)}}
@keyframes madriPulse{0%,100%{transform:scale(1)}50%{transform:scale(1.04)}}
@media (prefers-reduced-motion:reduce){
  .madri-motion--up,.madri-motion--left,.madri-motion--right,.madri-motion--zoom{opacity:1 !important;transform:none !important;animation:none !important}
  .madri-motion--float,.madri-motion--pulse{animation:none !important}
}
`;

export function ensureBuilderEffectCss() {
  if (typeof document === 'undefined') return;
  if (document.getElementById('madri-effect-css')) return;
  const el = document.createElement('style');
  el.id = 'madri-effect-css';
  el.textContent = MOTION_CSS + COUNT_UP_CSS;
  document.head.appendChild(el);
}
